import script from "./interview-process-panel2.vue?vue&type=script&lang=ts&setup=true"
export * from "./interview-process-panel2.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__